import { supabase } from "@/integrations/supabase/client";
import type {
  DecizieInregistrare,
  DecizieInregistrareInput,
} from "@/types/decizieInregistrare";

export async function getDecizieInregistrare(
  sessionId: string
): Promise<DecizieInregistrare | null> {
  const { data, error } = await supabase
    .from("decizie_inregistrare")
    .select("*")
    .eq("session_id", sessionId)
    .maybeSingle();

  if (error) {
    throw new Error(error.message);
  }

  if (!data) return null;

  return {
    ...data,
    sectors: Array.isArray(data.sectors) ? data.sectors : [],
  } as DecizieInregistrare;
}

export async function saveDecizieInregistrare(
  input: DecizieInregistrareInput
): Promise<DecizieInregistrare> {
  const { data, error } = await supabase
    .from("decizie_inregistrare")
    .upsert(input, { onConflict: "session_id" })
    .select()
    .single();

  if (error) {
    throw new Error(error.message);
  }

  if (!data) {
    throw new Error("Salvarea a eșuat");
  }

  return {
    ...data,
    sectors: Array.isArray(data.sectors) ? data.sectors : [],
  } as DecizieInregistrare;
}
